import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "flex-none font-sans font-bold break-normal text-gray-700 p-1" }
const _hoisted_3 = { class: "flex-none p-4 mt-2 rounded shadow bg-white" }
const _hoisted_4 = {
  key: 0,
  class: "block mt-2"
}
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-1 gap-3"
}
const _hoisted_6 = ["onDrop"]
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center w-full"
}
const _hoisted_8 = { class: "flex flex-col w-full h-32 border-4 border-blue-200 border-dashed hover:bg-gray-100 hover:border-gray-300" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center pt-7" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "w-8 h-8 text-gray-400 group-hover:text-gray-600",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "pt-1 text-sm tracking-wider text-gray-400 group-hover:text-gray-600" }, " Attach a file ")
], -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "top-4 right-4 absolute w-8 h-8 bg-red-400 rounded-full" }
const _hoisted_12 = { class: "text-xs text-pink-600" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "タイトル", -1)
const _hoisted_14 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "text-xs text-pink-600" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "表示期間", -1)
const _hoisted_18 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = { class: "text-xs text-pink-600" }
const _hoisted_21 = { class: "relative" }
const _hoisted_22 = { class: "text-xs text-pink-600" }
const _hoisted_23 = {
  key: 2,
  class: "block mt-2"
}
const _hoisted_24 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_25 = { class: "flex flex-wrap" }
const _hoisted_26 = ["id", "onUpdate:modelValue"]
const _hoisted_27 = ["for"]
const _hoisted_28 = { class: "flex-grow p-2 mt-2 rounded shadow bg-white" }
const _hoisted_29 = { class: "text-xs text-pink-600" }
const _hoisted_30 = { class: "flex-none text-right col-span-full mt-4" }
const _hoisted_31 = ["onClick"]

import { computed, onMounted, ref } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import Shop from "@/models/Shop";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Topic from "@/models/Topic";
import { uuid } from "vue-uuid";
import { Storage } from "aws-amplify";
import moment from "moment";
import Editor from "@tinymce/tinymce-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopicEdit',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const formSchema = yup.object({
  title: yup.string().required("必須項目です"),
  main_image_url: yup.string().required("必須項目です"),
  publish_from: yup.string(),
  publish_to: yup.string(),
  body: yup.string().required("必須項目です"),
});

useForm({ validationSchema: formSchema });

const title_field = useField<string>("title");
const main_image_url_field = useField<string>("main_image_url");
const publish_from_field = useField<string>("publish_from");
const publish_to_field = useField<string>("publish_to");
const body_field = useField<string>("body");

const topic = ref<Topic | null>(null);

const shops = ref<Shop[]>([]);

const title = title_field.value;
const title_error = title_field.errorMessage;

const main_image_url = main_image_url_field.value;
const main_image_url_error = main_image_url_field.errorMessage;

const publish_from = publish_from_field.value;
const publish_from_error = publish_from_field.errorMessage;

const publish_to = publish_to_field.value;
const publish_to_error = publish_to_field.errorMessage;

const body = body_field.value;
const body_error = body_field.errorMessage;

const mceCallback = ref<((uri: string, option: any) => void) | null>(null);

const type = computed<string>(() => {
  return route.params.type.toString();
});

const type_name = computed<string>(() => {
  switch (type.value) {
    case "trend":
      return "トレンド";
    case "salontopic":
      return "トピック";
    case "information":
      return "お知らせ";
    default:
      throw "No way";
  }
});

const salon_id = computed<string>(() => {
  return route.params.salon_id.toString();
});

const refresh = () => {
  if (store.state.is_loading) {
    return;
  }

  const id = route.params.topic_id as string | null;

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const result = await Shop.search(store.state.salon_id);
      shops.value = result.shops;

      console.log(shops);

      if (id) {
        topic.value = await Topic.get(id);
        console.log(topic.value);

        if (topic.value?.shop_ids) {
          shops.value.forEach((shop) => {
            if (topic.value!.shop_ids!.indexOf(shop.id) >= 0) {
              shop.selected = true;
            }
          });
        }

        title.value = topic.value.title;
        main_image_url.value = topic.value.main_image_url;

        if (topic.value.publish_from) {
          const date = topic.value.publish_from as Date;
          publish_from.value = moment(date).format("YYYY-MM-DD");
        }

        if (topic.value.publish_to) {
          const date = topic.value.publish_to as Date;
          publish_to.value = moment(date).format("YYYY-MM-DD");
        }

        body.value = topic.value.body;
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const onInputFileChanged = (e: any) => {
  console.log(e);

  const files = e.target.files as File[];
  if (files.length == 0) {
    return;
  }

  const file = files[0];

  upload(file);
};

const uploadFile = ref<HTMLInputElement>();

const onFilePicked = (callback: (uri: string, option: any) => void) => {
  mceCallback.value = callback;
  uploadFile.value?.click();
};

const onMainImageDropped = (e: DragEvent) => {
  console.log("onMainImageDropped");
  if (!e.dataTransfer) {
    return;
  }

  const file = e.dataTransfer.files[0];

  upload(file);
};

const removeMainImage = () => {
  main_image_url.value = "";
};

const upload = (file: File) => {
  const split = file.name.split(".");
  const filename = uuid.v4();
  const extension = split[split.length - 1];
  const contentType = extension == "png" ? "image/png" : "image/jpg";

  setTimeout(async () => {
    Storage.configure({ customPrefix: { public: "topics" } });
    const s3response = await Storage.put(`/${filename}.${extension}`, file, {
      contentType: contentType,
    });

    console.log(s3response);

    main_image_url.value = `${process.env.VUE_APP_HOST}/topics/${filename}.${extension}`;
  });
};

const onUploadFileChanged = async () => {
  if (!uploadFile.value?.files) {
    return;
  }
  try {
    const split = uploadFile.value.files[0].name.split(".");
    const extension = split[split.length - 1];
    const filename = `${uuid.v4()}.${extension}`;
    Storage.configure({ customPrefix: { public: "topics" } });
    await Storage.put(`/${filename}`, uploadFile.value.files[0], {
      contentType: extension == "png" ? "image/png" : "image/jpeg",
    });

    uploadFile.value.value = "";

    if (mceCallback.value) {
      mceCallback.value(`${process.env.VUE_APP_HOST}/topics/${filename}`, {});
    }
  } catch (error) {
    console.log("Error uploading file: ", error);
  }
};

const validate = async (): Promise<boolean> => {
  console.log(`validate()`);
  await title_field.validate();
  if (type.value != "information") {
    await main_image_url_field.validate();
  }
  await publish_from_field.validate();
  await publish_to_field.validate();
  await body_field.validate();

  return (
    !title_error.value &&
    !main_image_url_error.value &&
    !publish_from_error.value &&
    !publish_to_error.value &&
    !body_error.value
  );
};

const onSave = () => {
  console.log(`onSave()`);
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validate();
      if (!valid) {
        return;
      }

      let shopIds: string[] | null = null;

      shops.value.forEach((shop) => {
        if (shop.selected) {
          if(!shopIds) {
            shopIds = [];
          }
          shopIds.push(shop.id);
        }
      });

      if (!topic.value) {
        await Topic.register(
          type.value,
          salon_id.value == "system" ? null : salon_id.value,
          shopIds,
          title.value,
          type.value == "information"
            ? "https://salomedi.net/topics/empty.png"
            : main_image_url!.value,
          body.value,
          publish_from.value ? moment(publish_from.value).toDate() : null,
          publish_to.value ? moment(publish_to.value).toDate() : null
        );
      } else {
        await Topic.update(
          topic.value!.id,
          shopIds,
          title.value,
          type.value == "information"
            ? "https://salomedi.net/topics/empty.png"
            : main_image_url.value!,
          body.value,
          publish_from.value ? moment(publish_from.value).toDate() : null,
          publish_to.value ? moment(publish_to.value).toDate() : null
        );
      }

      if (type.value == "trend") {
        router.push(`/trends`);
      } else if (type.value == "salontopic") {
        router.push(`/salontopics`);
      } else if (type.value == "information") {
        router.push(`/information`);
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
  console.log(this);
};

onMounted(() => {
  refresh();
});

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(type_name)) + "追加 ", 1),
    _createElementVNode("div", _hoisted_3, [
      (_unref(type) != 'information')
        ? (_openBlock(), _createElementBlock("label", _hoisted_4, "メイン画像"))
        : _createCommentVNode("", true),
      (_unref(type) != 'information')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "m-4",
              onDrop: _withModifiers(onMainImageDropped, ["prevent"]),
              onDragenter: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
              onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              (!_unref(main_image_url))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("input", {
                        type: "file",
                        class: "opacity-0",
                        onChange: onInputFileChanged
                      }, null, 32)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(main_image_url))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "relative w-96",
                    onClick: removeMainImage
                  }, [
                    _createElementVNode("img", { src: _unref(main_image_url) }, null, 8, _hoisted_10),
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_fa, {
                        icon: "trash",
                        class: "text-sm text-center text-white mt-2 ml-2"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(main_image_url_error)), 1)
            ], 40, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["px-3 py-2 max-w-full w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(title_error) }]),
            placeholder: "タイトル",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(title) ? (title).value = $event : null))
          }, null, 2), [
            [_vModelText, _unref(title)]
          ]),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(title_error)), 1)
        ])
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: _normalizeClass(["px-3 py-2 w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(publish_from_error) }]),
            placeholder: "表示期間(開始)",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(publish_from) ? (publish_from).value = $event : null))
          }, null, 2), [
            [_vModelText, _unref(publish_from)]
          ]),
          _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(publish_from_error)), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: _normalizeClass(["px-3 py-2 w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(publish_to_error) }]),
            placeholder: "表示期間(終了)",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(publish_to) ? (publish_to).value = $event : null))
          }, null, 2), [
            [_vModelText, _unref(publish_to)]
          ]),
          _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(publish_to_error)), 1)
        ])
      ]),
      (_unref(type) == 'salontopic')
        ? (_openBlock(), _createElementBlock("label", _hoisted_23, "掲載店舗"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shops.value, (shop) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex items-center mr-4",
              key: shop.id
            }, [
              _withDirectives(_createElementVNode("input", {
                id: `inline-checkbox-${shop.id}`,
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((shop.selected) = $event),
                class: "w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              }, null, 8, _hoisted_26), [
                [_vModelCheckbox, shop.selected]
              ]),
              _createElementVNode("label", {
                for: `inline-checkbox-${shop.id}`,
                class: "ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              }, _toDisplayString(shop.name), 9, _hoisted_27)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(_unref(Editor), {
        class: _normalizeClass({ 'border-pink-600': _unref(body_error) }),
        apiKey: "6q2dpclc7cej6s5lf27smv4shxp5gq17tspjczs8owhanety",
        init: {
          language: 'ja',
          height: 480,
          plugins: 'link image code',
          menubar: 'edit insert format forecolor table code',
          toolbar:
            'insertfile undo redo | styleselect | forecolor backcolor | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image pagebreak | code',
          file_picker_types: 'image media',
          file_picker_callback: onFilePicked,
          block_unsupported_drop: false,
        },
        modelValue: _unref(body),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(body) ? (body).value = $event : null))
      }, null, 8, ["class", "init", "modelValue"]),
      _createElementVNode("input", {
        type: "file",
        ref_key: "uploadFile",
        ref: uploadFile,
        accept: "image/jpeg,image/png",
        style: {"width":"0px"},
        onChange: onUploadFileChanged
      }, null, 544),
      _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(body_error)), 1)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("button", {
        class: "shadow bg-yellow-700 hover:bg-yellow-500 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded",
        type: "button",
        onClick: _withModifiers(onSave, ["prevent"])
      }, " 登録 ", 8, _hoisted_31)
    ])
  ]))
}
}

})